// src/general.ts
import { v4 as uuidv4 } from 'uuid'; // Import the UUID library

export const rmspace = (str: any): string => {
    return String(str).replace(/\s+/g, '_');
};

// in /utils/general.ts

export const displayPrice = (price: any, currencyName: string = '') => {
    const numericPrice = typeof price === 'number' ? price : parseFloat(price);
    return !isNaN(numericPrice) ? `${currencyName}${numericPrice.toFixed(2)}` : ''; // Format to 2 decimal places with currency
};

export const toTitleCase = (str: string): string => {
    return str.replace(
        /\w\S*/g,
        (text: string) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

export const generateUniqueKey = (productId: number, selectedOptions: any) => {

    let key = `${productId}`;

    // Check if selected options are empty; if so, generate a UUID
    if (!selectedOptions.add_ons && !selectedOptions.toppings && !selectedOptions.specifications) {
        // return `${key}_${uuidv4()}`; // Return a unique key based on UUID
        return `${key}`; // Return a unique key based on UUID
    }

    // Otherwise, build the key based on options
    ['add_ons', 'toppings', 'specifications'].forEach(type => {
        if (selectedOptions[type]) {
            selectedOptions[type].forEach((option: any) => {
                key += `_${option.name.replace(/\s+/g, '_')}`;
            });
        }
    });

    return key;
};

export const generateUniqueKey4ChkOut = (productId: number, selectedOptions: any) => {

    let key = `${productId}`;

    // Check if selected options are empty; if so, generate a UUID
    if (!selectedOptions.add_ons && !selectedOptions.toppings && !selectedOptions.specifications) {
        return `${key}_${uuidv4()}`; // Return a unique key based on UUID
        // return `${key}`; // Return a unique key based on UUID
    }

    // Otherwise, build the key based on options
    ['add_ons', 'toppings', 'specifications'].forEach(type => {
        if (selectedOptions[type]) {
            selectedOptions[type].forEach((option: any) => {
                key += `_${option.name.replace(/\s+/g, '_')}`;
            });
        }
    });

    return key;
};